/* eslint-disable */

export default function checkCardsAvailability() {
  // Extract store hash from Shopify.shop
  let storeHash = '';
  if (window.Shopify && Shopify.shop) {
    storeHash = Shopify.shop.replace(/\.myshopify\.com$/, '');
  }
  if (storeHash === 'citta-dev') {
    storeHash = 'citta-nz-b2c';
  }
  if (!storeHash) return;

  // Function to enable notify me functionality on button
  function enableNotifyMeButton(button, variantId) {
    button.classList.add('btn--notify-me');
    button.removeAttribute('disabled');
    button.style.pointerEvents = '';
    button.style.cursor = '';

    const buttonTextSpan = button.querySelector('.product-card__atc-text');
    if (buttonTextSpan) {
      buttonTextSpan.textContent = 'Notify Me When Back In Stock';
    }

    // Clone button to avoid duplicate listeners
    const newButton = button.cloneNode(true);
    
    // Change button type from "submit" to "button" to prevent form submission
    newButton.type = 'button';
    
    // Mark button as card button to avoid conflicts with product page
    newButton.setAttribute('data-card-button', 'true');
    
    // Replace original button
    button.parentNode.replaceChild(newButton, button);
    
    // Open notify me modal via custom event (handled by product/notifyMe.js)
    newButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Dispatch custom event with variant ID
      document.dispatchEvent(new CustomEvent('notifyMe:open', {
        detail: { variantId: variantId },
        bubbles: true
      }));
    });

    return newButton;
  }

  // Function to process availability data and update cards
  function processAvailabilityData(availabilityData, cardMap) {
    // Process each product's availability data (array of objects)
    if (!Array.isArray(availabilityData)) return;
    
    availabilityData.forEach((productData) => {
      const productHandle = productData.handle;
      if (!productHandle) return;
      
      const cardInfo = cardMap[productHandle];
      if (!cardInfo) return;

      const { form, variantId, submitButton } = cardInfo;

      // Find the variant in the product data
      if (productData.variants && productData.variants.edges) {
        const currentVariant = productData.variants.edges.find((edge) => {
          const variantGid = edge.node?.id || edge.id;
          const variantIdFromGid =
            typeof variantGid === 'string' && variantGid.includes('/')
              ? variantGid.split('/').pop()
              : variantGid;
          return String(variantIdFromGid) === String(variantId);
        });

        if (currentVariant) {
          const inventoryItem = currentVariant.node?.inventoryItem;
          const inventoryLevels = inventoryItem?.inventoryLevels?.edges;

          if (inventoryLevels) {
            const aapWarehouse = inventoryLevels.find(
              (edge) => edge.node?.location?.name?.toLowerCase() === 'aap warehouse'
            );

            if (aapWarehouse) {
              const availableQuantity = aapWarehouse.node?.quantities?.find(
                (qty) => qty.name === 'available'
              );

              if (availableQuantity) {
                // Get purchase order status and estimated stock date from form
                const isPurchaseOrder = form.getAttribute('data-is-purchase-order') === 'true';
                const estimatedStockDate = form.getAttribute('data-estimated-stock-date');
                
                if (isPurchaseOrder && availableQuantity.quantity < 1 && estimatedStockDate) {
                  // Enable notify me functionality
                  enableNotifyMeButton(submitButton, variantId);
                } else if (!isPurchaseOrder && availableQuantity.quantity === 0 && !estimatedStockDate) {
                  // Set button to sold out if not purchase order, quantity is 0, and no estimated stock date
                  submitButton.setAttribute('data-sold-out', 'true');
                  submitButton.disabled = true;
                  
                  // Change button text to "Sold Out"
                  const buttonTextSpan = submitButton.querySelector('.product-card__atc-text');
                  if (buttonTextSpan) {
                    buttonTextSpan.textContent = 'Sold Out';
                  }
                  
                  // Remove any notify-me classes if present
                  submitButton.classList.remove('btn--notify-me');
                } else {
                  // Re-enable button for normal submission
                  submitButton.style.pointerEvents = '';
                  submitButton.style.cursor = '';
                  if (!submitButton.classList.contains('btn--notify-me')) {
                    submitButton.removeAttribute('disabled');
                  }
                }
              }
            }
          }
        }
      }
    });
  }

  // Function to check availability for all cards in batch
  async function checkCardsAvailabilityBatch(cardMap, productIds) {
    try {
      if (productIds.length === 0) return;

      const endpoint = `${apiURL}/api/${storeHash}/products/quantities`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          product_ids: productIds,
          max_products: 250,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Process the response data
      if (data?.data?.nodes) {
        processAvailabilityData(data?.data?.nodes, cardMap);
      }
    } catch (error) {
      console.error('Error checking cards availability:', error);
      // Re-enable all buttons on error
      Object.values(cardMap).forEach(({ submitButton }) => {
        if (submitButton) {
          submitButton.style.pointerEvents = '';
          submitButton.style.cursor = '';
          if (!submitButton.classList.contains('btn--notify-me')) {
            submitButton.removeAttribute('disabled');
          }
        }
      });
    }
  }

  function processCards() {
    // Only select forms that haven't been checked yet
    // This ensures we only process new products from pagination, not re-process existing ones
    const productCards = document.querySelectorAll('form[is="product-form"][data-product-handle]:not([data-availability-checked])');
    if (!productCards.length) return;

    // Map to store card information by product handle for this batch
    const cardMap = {};
    const productIds = [];

    productCards.forEach((form) => {
      // Mark as checked immediately to prevent duplicate processing
      // This is the identifier that distinguishes processed vs new products
      form.setAttribute('data-availability-checked', 'true');

      // Get product handle and ID from data attributes
      const productHandle = form.getAttribute('data-product-handle');
      const productId = form.getAttribute('data-product-id');
      
      if (!productHandle || !productId) return; // Skip if missing required data

      const submitButton = form.querySelector('button[type="submit"]');
      if (!submitButton) return;

      // Get variant ID
      const variantIdInput = form.querySelector('.product-variant-id');
      const variantId = variantIdInput ? variantIdInput.value : null;
      if (!variantId) return;

      // Store card information keyed by handle (for matching with API response)
      cardMap[productHandle] = {
        form,
        variantId,
        submitButton,
      };

      // Collect product IDs for API request
      productIds.push(productId);

      // Disable button while checking
      submitButton.disabled = true;
      submitButton.style.pointerEvents = 'none';
      submitButton.style.cursor = 'not-allowed';
    });

    // Check availability for all cards in batch
    if (Object.keys(cardMap).length > 0) {
      checkCardsAvailabilityBatch(cardMap, productIds);
    }
  }

  // Process existing cards
  processCards();

  // Only watch for new cards on collection or search pages
  const isCollectionPage = document.body.classList.contains('collection-template');
  const isSearchPage = document.body.classList.contains('search-template');
  
  if (isCollectionPage || isSearchPage) {
    // Find the product grid container to observe (more efficient than observing entire body)
    const productContainer = document.getElementById('ProductGridContainer') || 
                             document.querySelector('.products-list') ||
                             document.querySelector('grid-list');
    
    if (productContainer) {
      // Debounce to batch multiple rapid mutations
      let debounceTimer = null;
      
      const observer = new MutationObserver((mutations) => {
        // Quick check: only process if forms are actually added
        let hasNewCards = false;
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node only
              // Direct match check (fastest)
              if (node.matches && node.matches('form[is="product-form"][data-product-handle]:not([data-availability-checked])')) {
                hasNewCards = true;
                break;
              }
              // Only querySelector if node might contain forms (avoid expensive queries)
              if (node.querySelectorAll && (node.tagName === 'FORM' || node.querySelector('form'))) {
                const newCards = node.querySelectorAll('form[is="product-form"][data-product-handle]:not([data-availability-checked])');
                if (newCards.length > 0) {
                  hasNewCards = true;
                  break;
                }
              }
            }
          }
          if (hasNewCards) break;
        }
        
        // Debounce: wait for mutations to settle before processing
        if (hasNewCards) {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            processCards();
          }, 100); // 100ms debounce
        }
      });

      // Observe only the product container (much more efficient than entire body)
      observer.observe(productContainer, {
        childList: true,
        subtree: true
      });
    }
  }
}

